import React, { useState, useEffect } from 'react';
// ❌ RIMUOVI: import { createPortal } from 'react-dom';

const API_BASE_URL = process.env.REACT_APP_API_URL_NODE;

export default function POIEnrichmentForm({ onClose, poi }) {
    const [loading, setLoading] = useState(false);
    const [trackingId, setTrackingId] = useState(null);
    const [formUrl, setFormUrl] = useState(null);
    const [error, setError] = useState(null);

    const coords = poi?.geometry?.coordinates;
    const lat = coords?.[1];
    const lng = coords?.[0];
    const name = poi?.properties?.name || 'Punto di interesse';
    const id = poi?.properties?.id;

    useEffect(() => {
        if (!coords) {
            setTrackingId(null);
            setFormUrl(null);
            setError(null);
            return;
        }

        const fetchFormData = async () => {
            setLoading(true);
            setError(null);

            try {
                const response = await fetch(`${API_BASE_URL}/api/poi-from-gestore`, {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({ name, lat, lng, id })
                });

                const result = await response.json();

                if (result.success) {
                    setTrackingId(result.tracking_id);
                    setFormUrl(result.form_url);
                } else {
                    setError(result.error || 'Errore durante la generazione del form');
                }
            } catch (err) {
                console.error('❌ Errore API:', err);
                setError('Errore di connessione al server');
            } finally {
                setLoading(false);
            }
        };

        fetchFormData();
    }, [coords, name, lat, lng]);

    const handleOpenForm = () => {
        if (trackingId) {
            navigator.clipboard.writeText(trackingId).catch(() => { });
        }
        if (formUrl) {
            window.open(formUrl, '_blank');
        }
        onClose();
    };

    const googleMapsUrl = `https://www.google.com/maps?q=${lat},${lng}`;

    // ✅ RETURN NORMALE (senza createPortal)
    return (
        <div
            data-react-managed="true"  // ✅ AGGIUNGI QUESTO
            style={{
                position: 'fixed',
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                background: 'rgba(0, 0, 0, 0.8)',
                zIndex: 9999,
                // ...
            }}
            onClick={onClose}
        >
            <div
                style={{
                    background: 'white',
                    borderRadius: '8px',
                    maxWidth: '500px',
                    width: '100%',
                    padding: '30px',
                    textAlign: 'center',
                    boxShadow: '0 10px 40px rgba(0,0,0,0.3)'
                }}
                onClick={(e) => e.stopPropagation()}
            >
                {loading ? (
                    <>
                        <div style={{ fontSize: '48px', marginBottom: '16px' }}>⏳</div>
                        <h2 style={{ margin: '0 0 16px 0', color: '#333' }}>Caricamento...</h2>
                        <p style={{ color: '#666', lineHeight: '1.6' }}>
                            Preparazione del form in corso...
                        </p>
                    </>
                ) : error ? (
                    <>
                        <div style={{ fontSize: '48px', marginBottom: '16px' }}>❌</div>
                        <h2 style={{ margin: '0 0 16px 0', color: '#d32f2f' }}>Errore</h2>
                        <p style={{ color: '#666', lineHeight: '1.6', marginBottom: '20px' }}>
                            {error}
                        </p>
                        <button
                            onClick={onClose}
                            style={{
                                padding: '12px 24px',
                                background: '#ddd',
                                color: '#333',
                                border: 'none',
                                borderRadius: '6px',
                                cursor: 'pointer',
                                fontWeight: '600',
                                fontSize: '14px'
                            }}
                        >
                            Chiudi
                        </button>
                    </>
                ) : (
                    <>
                        <div style={{ fontSize: '48px', marginBottom: '16px' }}>📝</div>
                        <h2 style={{ margin: '0 0 16px 0', color: '#333' }}>Aggiungi Informazioni</h2>
                        <p style={{ color: '#666', lineHeight: '1.6', marginBottom: '20px' }}>
                            Stai per aprire un form per aggiungere informazioni su:<br />
                            <strong style={{ color: '#4CAF50', fontSize: '16px' }}>{name}</strong>
                        </p>

                        <div style={{
                            background: '#f0f7ff',
                            padding: '12px',
                            borderRadius: '6px',
                            margin: '16px 0',
                            borderLeft: '4px solid #2196F3'
                        }}>
                            <div style={{ fontSize: '12px', color: '#1976D2', fontWeight: '600', marginBottom: '4px' }}>
                                📍 Coordinate OSM
                            </div>
                            <code style={{
                                background: 'white',
                                padding: '6px 10px',
                                borderRadius: '4px',
                                display: 'inline-block',
                                fontSize: '12px'
                            }}>
                                {lat?.toFixed(6)}, {lng?.toFixed(6)}
                            </code>
                            <div style={{ marginTop: '8px' }}>
                                <a href={googleMapsUrl}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    style={{ color: '#2196F3', fontSize: '12px', textDecoration: 'none' }}
                                >
                                    🗺️ Vedi su Google Maps
                                </a>
                            </div>
                        </div>

                        {trackingId && (
                            <div style={{
                                background: '#f0f7ff',
                                padding: '12px',
                                borderRadius: '6px',
                                margin: '16px 0',
                                borderLeft: '4px solid #2196F3'
                            }}>
                                <div style={{ fontSize: '12px', color: '#1976D2', fontWeight: '600', marginBottom: '4px' }}>
                                    🔑 Tracking ID
                                </div>
                                <code style={{
                                    background: 'white',
                                    padding: '6px 10px',
                                    borderRadius: '4px',
                                    display: 'inline-block',
                                    fontSize: '13px'
                                }}>
                                    {trackingId}
                                </code>
                                <div style={{ fontSize: '11px', color: '#666', marginTop: '6px' }}>
                                    Conservalo per controllare lo stato
                                </div>
                            </div>
                        )}

                        <div style={{
                            background: '#fff3e0',
                            padding: '12px',
                            borderRadius: '6px',
                            margin: '16px 0',
                            fontSize: '13px',
                            color: '#f57c00'
                        }}>
                            ⚠️ Questa piattaforma raccoglie informazioni utili agli escursionisti. I contenuti devono descrivere servizi e condizioni reali del punto (acqua, riparo, orari, accessibilità). Non sono ammessi contenuti pubblicitari, promozioni o materiale di marketing.
                        </div>

                        <div style={{
                            background: '#fff3e0',
                            padding: '12px',
                            borderRadius: '6px',
                            margin: '16px 0',
                            fontSize: '13px',
                            color: '#f57c00'
                        }}>
                            ⚠️ Sarai reindirizzato a Google Forms
                        </div>

                        <div style={{ display: 'flex', gap: '10px', marginTop: '24px' }}>
                            <button
                                onClick={onClose}
                                style={{
                                    flex: 1,
                                    padding: '12px',
                                    background: '#ddd',
                                    color: '#333',
                                    border: 'none',
                                    borderRadius: '6px',
                                    cursor: 'pointer',
                                    fontWeight: '600',
                                    fontSize: '14px'
                                }}
                            >
                                Annulla
                            </button>
                            <button
                                onClick={handleOpenForm}
                                disabled={!formUrl}
                                style={{
                                    flex: 2,
                                    padding: '12px',
                                    background: formUrl ? '#4CAF50' : '#ccc',
                                    color: 'white',
                                    border: 'none',
                                    borderRadius: '6px',
                                    cursor: formUrl ? 'pointer' : 'not-allowed',
                                    fontWeight: '700',
                                    fontSize: '14px'
                                }}
                            >
                                📋 Copia Tracking & Apri Form
                            </button>
                        </div>

                        <div style={{ marginTop: '16px', fontSize: '12px', color: '#666' }}>
                            Il tracking ID verrà copiato automaticamente
                        </div>
                    </>
                )}
            </div>
        </div>
    );
}